import * as firebase from "firebase";
import {StaffAccessLevels} from "@/enums/StaffAccessLevels";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import {getRegionName} from "@/utils/functionsRegion";

export default {
  name: "DigitalSignageTVLogin",
  data() {
    return {
      email: "",
      password: "",
      loading: false,
      error: null,
      isLogin: false
    }
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  methods: {
    async submit() {
      this.loading = true;
      const tvId = this.$route.params.id;

      await firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(async firebaseUser => {
          if (firebaseUser.user) {
            const { claims } = await firebaseUser.user.getIdTokenResult()

            if([StaffAccessLevels.MaintenanceUser, StaffAccessLevels.MaintenanceAdmin].includes(claims.accessLevel)) {
              this.error = this.$t('Login.YouHaveInsufficientPermissionsToLogIntoStaffHub');
            }

            if(!tvId) {
              this.error = this.$t("DigitalSignageLogin.ScanQRCodeOneMoreTime");
            }

            const result = await firebase.app()
              .functions(getRegionName())
              .httpsCallable("getUserCustomToken")({ userId: firebaseUser.user.uid, claims: { sessionType: 'tvDisplay', skipSessionTimeout: true} });

            await firebase
              .firestore()
              .collection("digitalSignageTV")
              .doc(tvId)
              .update({
                token: result?.data?.customToken
              });

            this.isLogin = true;
            this.error = null;
          }
        }).catch(error => {
          console.error("ERROR: ", error)
          this.error = this.$t('Login.YourUsernameOrPasswordIsIncorrect');
        }).finally(() => {
          this.loading = false;
        })
    },
    openForgotPassword() {
      this.$router.push(`/digital-signage-tv-forgot-password?id=${this.$route.params.id}`)
    }
  }
}